import { render, staticRenderFns } from "./productUnitList.vue?vue&type=template&id=19f64a7d&scoped=true"
import script from "./productUnitList.vue?vue&type=script&lang=js"
export * from "./productUnitList.vue?vue&type=script&lang=js"
import style0 from "./productUnitList.vue?vue&type=style&index=0&id=19f64a7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f64a7d",
  null
  
)

export default component.exports